import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ExprenceSection = [
  {
    date: "Present",
    company: (
      <h2>
        A2 Digi <br />
        Solution
      </h2>
    ),
    description:
      "Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna",
  },
  {
    date: "2020-23",
    company: (
      <h2>
        Hem ocean <br /> Outsourcing
      </h2>
    ),
    description:
      "Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna",
  },
];

const Exp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 500);
  }, []);

  // Slider settings for react-slick
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="section" id="section-exp">
      <div className="content flex justify-between items-start mb-6">
        <div className="titles">
          <div className="title text-2xl font-bold">Experience</div>
        </div>
      </div>
      <Slider className="" {...settings} ref={sliderRef}>
        {ExprenceSection.map((route, index) => {
          const { date, company, description } = route;
          return (
            <div
              key={index}
              className="content flex justify-items-start gap-20 text-[14px]"
            >
              <div className={`exp-container ${isVisible ? "slide-up" : ""}`}>
                <span className="exp-date">{date}</span>
                <div className="exp-company">{company}</div>
                <div className="exp-description">
                  <p>{description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Exp;
